export default __webpack_public_path__ + "static/media/la_capelle15.fdf0d0c2.jpg";